module.exports = __webpack_public_path__ + "static/cedente-plataforma-56628a78de98ecbd0dc231d4d4266bb0.png";